"use client";

import { useState } from "react";
import toast from "react-hot-toast";
import api from "@/libs/axios";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterSignup() {
    const [email, setEmail] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const trimmed = email.trim();
        if (!EMAIL_REGEX.test(trimmed)) {
            toast.error("Enter a valid email address");
            return;
        }

        try {
            setIsSubmitting(true);
            const { data } = await api.post("/api/newsletter/subscribe", { email: trimmed });

            if (data.alreadySubscribed) {
                toast("You're already on the list!");
            } else {
                toast.success("Subscribed! Welcome aboard.");
            }
            setEmail("");
        } catch (err) {
            console.error("Newsletter subscribe error:", err);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="col-span-3 md:col-span-3 flex flex-col gap-3">
            <h3 className="text-base md:text-2xl font-bold">Join the list</h3>
            <p className="text-[12px] md:text-base">
                Exclusive offers, new arrivals, & freshly brewed coffee content
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-2 w-full">
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    disabled={isSubmitting}
                    className="py-2 px-3 w-full bg-transparent border text-[12px] md:text-base border-gray-300 text-white disabled:opacity-60"
                />
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-gray-200 text-black px-3 py-2 text-center text-[12px] disabled:opacity-60 disabled:cursor-not-allowed"
                >
                    {isSubmitting ? "Subscribing..." : "Subscribe"}
                </button>
            </form>
        </div>
    );
}